module.exports = __webpack_public_path__ + "img/national-geographic-blacklogo@3x.f0fc7861.png";